import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { switchMap, tap } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { SpamVerificationActions } from '@core/spam-verification-data';
import { SpamVerificationService } from '@core/spam-verification-logic';
import type { CompanyVerificationRequestStatus } from '@core/spam-verification-types';
import { SpamVerificationStatusInfoboxComponent } from '@core/spam-verification-ui';

@Component({
  selector: 'rt-spam-verification-infobox-container',
  template: `
    @if (companyVerificationRequestStatus) {
      <rt-spam-verification-status-infobox
        [status]="companyVerificationRequestStatus"
      ></rt-spam-verification-status-infobox>
    }
  `,
  styleUrls: ['./spam-verification-infobox-container.component.less'],
  imports: [SpamVerificationStatusInfoboxComponent],
})
export class SpamVerificationInfoboxContainerComponent {
  private readonly destroyRef = inject(DestroyRef);
  public companyVerificationRequestStatus: CompanyVerificationRequestStatus;

  constructor(
    private service: SpamVerificationService,
    private store: Store,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.service.verificationRequired$
      .pipe(
        filterBoolean,
        tap(() => {
          this.store.dispatch(SpamVerificationActions.fetch());
        }),
        switchMap(() => this.service.selectSpamVerificationStatus$),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(status => {
        this.companyVerificationRequestStatus = status;
        this.cdRef.detectChanges();
      });
  }
}
